// GENERATED by tools/levels (pnpm levels:build). Do not edit by hand.
import type { SortingPack } from "./schema.ts";

export const SORTING_CONTENT_VERSION = "sorting-1.0.0";

/** sha256 of each frozen chapter pack, checked by `pnpm levels:check`. */
export const SORTING_PACK_SHA256: Readonly<Record<number, string>> = {
  1: "13540eea4d984b84dc7c7da5076e78323de8fdacfdf235b0fbe563b7fc336988",
  2: "f23c109914fedbbb3b5f5c3a72684c1ab85431205680766d237f3916acfbcb2a",
  3: "3875653d81eb77977f870d036ac8a30283fd82321bfc3e27c16e0dc133475999",
  4: "49b8b7b33404afdd0a94b6d123a590a52ceeb1a824940bbd2fdd0a0195ea4957",
  5: "9fe358fd629a0593a54b6e8dc308942416c3aae447849e819bdc2c3de827420b",
  6: "10dd467846a53959f62687ccab9943db501a4ae25e903f0f2fbfc8b2ec5a0a2d",
  7: "c348f06f17e0645b6f5db692b06b996887e43632de36f7e142f710f5f19d8c0d",
  8: "68a7a9e3040813e3bdee890b2c40d50610564461c56eec5a0ab44cf2032b48b1",
  9: "3c37675b09e262b10a871885f349393dc2bf606cf1b8f9d263025f45d3ee6a66",
  10: "54ab1d55375ad56f79a84208fc77ec70d954abb0c3763a7c62401fa2944976c3",
};

/** Lazy loaders: the client only downloads the chapter being played. */
export const SORTING_PACK_LOADERS: Readonly<Record<number, () => Promise<SortingPack>>> = {
  1: () => import("../../packs/sorting/sorting-1.0.0/chapter-01.json").then((m) => m.default as SortingPack),
  2: () => import("../../packs/sorting/sorting-1.0.0/chapter-02.json").then((m) => m.default as SortingPack),
  3: () => import("../../packs/sorting/sorting-1.0.0/chapter-03.json").then((m) => m.default as SortingPack),
  4: () => import("../../packs/sorting/sorting-1.0.0/chapter-04.json").then((m) => m.default as SortingPack),
  5: () => import("../../packs/sorting/sorting-1.0.0/chapter-05.json").then((m) => m.default as SortingPack),
  6: () => import("../../packs/sorting/sorting-1.0.0/chapter-06.json").then((m) => m.default as SortingPack),
  7: () => import("../../packs/sorting/sorting-1.0.0/chapter-07.json").then((m) => m.default as SortingPack),
  8: () => import("../../packs/sorting/sorting-1.0.0/chapter-08.json").then((m) => m.default as SortingPack),
  9: () => import("../../packs/sorting/sorting-1.0.0/chapter-09.json").then((m) => m.default as SortingPack),
  10: () => import("../../packs/sorting/sorting-1.0.0/chapter-10.json").then((m) => m.default as SortingPack),
};
